import React, { useEffect, useState } from "react";
import MenuItem from "../../components/admin/menu/MenuItem";
import { useDocumentTitle } from "../../hooks";
import BackendLayout from "../../layouts/BackendLayout";
import { useDispatch } from "react-redux";
import { getMasterTopPageSettings } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import { MASTER_DASHBOARD } from "../../constants/routes";
import {PageTitle, RedirectAlert} from "../../components";
import { clearPageLoading, setPageLoading } from "../../store/actions";
import {errorStatusHandle} from "../../utils";
import { ModalNotPermission } from "../../components/modal";
import {MASTER_DASHBOARD_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

const MasterTopPage = () => {
  useRedirectPage(MASTER_DASHBOARD_PAGE);
  const [menuItems, setMenuItems] = useState([]);
  const dispatch = useDispatch();
  useDocumentTitle("マスタトップ - 点検王");
  const breadcrumb = getPageBreadcrumb(MASTER_DASHBOARD);
  const [openModal, setOpenModal] = useState();

  //Function help to set page settings
  const setTopPageSettings = async (e) => {
    dispatch(setPageLoading());
    try {
      const pageSettings = await getMasterTopPageSettings();
      dispatch(setPageSettings(pageSettings));
      setMenuItems(pageSettings.menu_items);
    } catch (e) {
      errorStatusHandle(e);
    } finally {
      dispatch(clearPageLoading());
    }
  };

  useEffect(() => {
    setTopPageSettings().then();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <BackendLayout sidebar={true} breadcrumb={breadcrumb}>
      <PageTitle title="マスタトップ" />
      <div className="mt-[16px]">
        <RedirectAlert />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:gap-x-8 lg:gap-x-6 gap-x-8 lg:gap-y-8 gap-y-[26px] py-[20px] max-w-[1080px]">
        {menuItems.map((item, index) => {
          if (item.hasOwnProperty("access") && item.access === false) {
            return (
              <MenuItem
                key={index}
                menu={item.name}
                feature="master"
                permission={false}
                setOpenModal={setOpenModal}
              />
            );
          }
          return <MenuItem key={index} menu={item.name} feature="master" />;
        })}
      </div>
      <ModalNotPermission openModal={openModal} setOpenModal={setOpenModal} />
    </BackendLayout>
  );
};

export default MasterTopPage;
